import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import styled from 'styled-components';

import { otherColors } from '@/styles/colors';

interface IProps {
  className?: string;
  defaultKey: string;
  tabs: { title: string; content: React.ReactElement; key: string }[];
}

const ResourceViewWithTabs = ({ defaultKey, tabs, className }: IProps): React.ReactElement => {
  return (
    <TabsStyled defaultActiveKey={defaultKey} className={className} fill>
      {tabs.map(tab => (
        <Tab key={tab.key} eventKey={tab.key} title={tab.title}>
          {tab.content}
        </Tab>
      ))}
    </TabsStyled>
  );
};

export { ResourceViewWithTabs };

const TabsStyled = styled(Tabs)`
  .nav-item {
    text-decoration: none;
    color: #5a5a5a;
    border-radius: 8px 8px 0 0;
    text-align: center;

    &.active {
      color: ${otherColors.lxc.blue};
    }
  }

  .nav-tabs {
    border-bottom: none;
  }
`;
